// ValidationIndicator.jsx
import React from "react";

const ValidationIndicator = ({
  isSearching = false,
  validationResult = null,
  error = null,
  searchingText = "Validating...",
  searchingColor = "#007bff",
  errorColor = "#dc3545",
  fontSize = "12px",
  marginTop = "4px",
  className = "",
  style = {},
}) => {
  console.log("🎯 ValidationIndicator render with props:", {
    isSearching,
    validationResult,
    error,
    hasValidationResult: !!validationResult,
    validationIsValid: validationResult?.isValid,
    validationMessage: validationResult?.message,
  });

  const baseStyle = {
    fontSize,
    marginTop,
    ...style,
  };

  // Don't render anything if there's nothing to show
  if (!isSearching && !validationResult && !error) {
    console.log("🚫 ValidationIndicator: Nothing to show, returning null");
    return null;
  }

  console.log("✅ ValidationIndicator: Will render content");

  return (
    <div className={`validation-indicator-container ${className}`}>
      {/* Searching indicator */}
      {isSearching && (
        <>
          {console.log("⏳ Rendering searching indicator:", searchingText)}
          <div
            className="validation-indicator searching"
            style={{
              ...baseStyle,
              color: searchingColor,
            }}
          >
            {searchingText}
          </div>
        </>
      )}

      {/* Validation error message */}
      {validationResult && !validationResult.isValid && (
        <>
          {console.log(
            "❌ Rendering validation error:",
            validationResult.message
          )}
          <div
            className="validation-message error"
            style={{
              ...baseStyle,
              color: errorColor,
            }}
          >
            {validationResult.message}
          </div>
        </>
      )}

      {/* General error message */}
      {error && (
        <>
          {console.log("💥 Rendering general error:", error)}
          <div
            className="validation-message error"
            style={{
              ...baseStyle,
              color: errorColor,
            }}
          >
            Error: {error}
          </div>
        </>
      )}
    </div>
  );
};

export default ValidationIndicator;
